import validate, {
  listOfFormsAreValidated,
} from 'containers/services/validateForm';
import {
  DOCUMENT,
  VEHICULE_EXPERTISE_FIELDS,
  VICTIM_EXPERTISE_FIELDS,
} from 'containers/data-structure';
import {
  TvehiculeExpertise,
  TvictimExpertise,
} from 'containers/common/LegalProceedings/ExpertReport/typings';
import { CorporealDocument } from 'containers/common/LegalProceedings/JudgementAdd/Forms/JudgementAddPrononcings/typings';
import { TYPE } from 'containers/common/LegalProceedings/ExpertReport/FormsByExpertiseType/constants';
import { get } from 'lodash';
import { INJURY_POST_DECEASED } from 'containers/PreOpeningPage/constants';

export const medicalExpertiseConstraint = () => {
  return {
    [VICTIM_EXPERTISE_FIELDS.ITT]: { presence: true },
    [VICTIM_EXPERTISE_FIELDS.IPP]: { presence: true },
    [VICTIM_EXPERTISE_FIELDS.MEDICAL_PHARMACEUTICAL_FEES]: {
      presence: true,
    },
    [VICTIM_EXPERTISE_FIELDS.THIRD_PARTY_APPEAL]: { presence: true },
    [VICTIM_EXPERTISE_FIELDS.PRETIUM_DOLORIS]: { presence: true },
    [VICTIM_EXPERTISE_FIELDS.AESTHETIC_DAMAGE_WITHOUT_CONSEQUENCE]: {
      presence: true,
    },
    [VICTIM_EXPERTISE_FIELDS.AESTHETIC_DAMAGE_WITH_CONSEQUENCE]: {
      presence: true,
    },
    [VICTIM_EXPERTISE_FIELDS.SCHOOLING_PREJUDICE]: {
      presence: true,
    },
    [VICTIM_EXPERTISE_FIELDS.CAREER_PREJUDICE]: {
      presence: true,
    },
  };
};
export const deceasedMedicalExpertiseConstraint = {
  [VICTIM_EXPERTISE_FIELDS.VICTIM_REVENUE]: { presence: true },
  [VICTIM_EXPERTISE_FIELDS.CAUSALITY_LINK]: { presence: true },
};

export const expertiseDocumentConstraint = {
  [DOCUMENT.NAME]: { presence: true },
  [DOCUMENT.TYPE]: { presence: true },
  [DOCUMENT.URL]: { presence: true },
};

export const mechanicalExpertiseConstraint = {
  [VEHICULE_EXPERTISE_FIELDS.DAMAGE_AMOUNT]: { presence: true },
};

export const accountingVictimExpertiseConstraint = {
  [VICTIM_EXPERTISE_FIELDS.FIXED_ANNUAL_INCOME]: { presence: true },
};

export const accountingVehicleExpertiseConstraint = {
  [VEHICULE_EXPERTISE_FIELDS.DAMAGE_AMOUNT]: { presence: true },
};

export const medicalExpertisesValidator = (
  medicalExpertise: TvictimExpertise,
) => {
  return get(medicalExpertise, 'injuryPostKey', '') === INJURY_POST_DECEASED
    ? validate(medicalExpertise, deceasedMedicalExpertiseConstraint)
    : validate(medicalExpertise, medicalExpertiseConstraint());
};

export const medicalExpertiseValidator = (
  medicalExpertise: TvictimExpertise,
) => {
  return validate(medicalExpertise, medicalExpertiseConstraint);
};

export const accountingExpertiseValidator = (
  accountingExpertise: any,
  type: string,
) => {
  return type === TYPE.VICTIM
    ? validate(accountingExpertise, accountingVictimExpertiseConstraint)
    : validate(accountingExpertise, accountingVehicleExpertiseConstraint);
};

export const mechanicalExpertiseValidator = (
  mechanicalExpertise: TvehiculeExpertise,
) => {
  return validate(mechanicalExpertise, mechanicalExpertiseConstraint);
};

export const expertiseDocumentValidator = (
  expertiseDocument: CorporealDocument,
) => {
  return validate(expertiseDocument, expertiseDocumentConstraint);
};

export const isMedicalExpertisesValidated = (expertise: TvictimExpertise) => {
  const medicalExpertiseFields = medicalExpertisesValidator(expertise);

  const expertiseDocument = expertiseDocumentValidator(
    get(expertise, 'victimExpertiseDocuments[0]', []),
  );

  return listOfFormsAreValidated([medicalExpertiseFields, expertiseDocument]);
};

export const isAccountingExpertisesValidated = (
  expertise: any,
  type: string,
) => {
  const accountingExpertiseFields = accountingExpertiseValidator(
    expertise,
    type,
  );

  const expertiseDocument = expertiseDocumentValidator(
    type === TYPE.VICTIM
      ? get(expertise, 'victimExpertiseDocuments[0]', [])
      : get(expertise, 'vehiculeExpertiseDocuments[0]', []),
  );

  return listOfFormsAreValidated([
    accountingExpertiseFields,
    expertiseDocument,
  ]);
};

export const isMechanicalExpertisesValidated = (
  expertise: TvehiculeExpertise,
) => {
  const mechanicalExpertiseFields = mechanicalExpertiseValidator(expertise);

  const expertiseDocument = expertiseDocumentValidator(
    get(expertise, 'vehiculeExpertiseDocuments[0]', []),
  );

  return listOfFormsAreValidated([
    mechanicalExpertiseFields,
    expertiseDocument,
  ]);
};
